module.exports = __webpack_public_path__ + "img/coinbankB26.4cc9e9a6.jpg";